module.exports = __webpack_public_path__ + "static/media/NotificationButtonIcon.64b21412.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/NotificationButtonIcon.svg
// module id = 316
// module chunks = 0